import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { PwaUpdateProvider } from '@/components/PwaUpdate';
import { ToastProvider } from '@/components/ToastProvider';
import { FamilyScopeProvider } from '@/features/family/scope-context';
import { queryClient } from '@/lib/query-client';
import { router } from '@/lib/router';
import '@/styles/globals.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <PwaUpdateProvider>
        <ToastProvider>
          <FamilyScopeProvider>
            <RouterProvider router={router} />
          </FamilyScopeProvider>
        </ToastProvider>
      </PwaUpdateProvider>
    </QueryClientProvider>
  </StrictMode>,
);
